var _excluded = ["children", "className", "component", "destructive", "disabled", "href", "icon", "small", "medium", "onClick", "primary", "secondary", "target", "tertiary", "tertiaryAlt", "type", "value"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import PropTypes from "prop-types";
import React, { forwardRef, useContext } from "react";
import AButtonGroupContext from "../AButtonGroup/AButtonGroupContext";
import "./AButton.scss";
var AButton = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
    propsClassName = _ref.className,
    component = _ref.component,
    _ref$destructive = _ref.destructive,
    destructive = _ref$destructive === void 0 ? false : _ref$destructive,
    disabled = _ref.disabled,
    href = _ref.href,
    icon = _ref.icon,
    _ref$small = _ref.small,
    small = _ref$small === void 0 ? false : _ref$small,
    _ref$medium = _ref.medium,
    medium = _ref$medium === void 0 ? false : _ref$medium,
    _onClick = _ref.onClick,
    primary = _ref.primary,
    secondary = _ref.secondary,
    target = _ref.target,
    tertiary = _ref.tertiary,
    tertiaryAlt = _ref.tertiaryAlt,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? "button" : _ref$type,
    value = _ref.value,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useContext = useContext(AButtonGroupContext),
    selectedValues = _useContext.selectedValues,
    toggleValue = _useContext.toggleValue;
  var className = "a-button focus-box-shadow a-button--";
  if (primary) {
    className += destructive ? "primary-destructive" : "primary";
  } else if (secondary) {
    className += destructive ? "secondary-destructive" : "secondary";
  } else if (tertiary) {
    className += "tertiary";
  } else if (tertiaryAlt) {
    className += "tertiary-alt";
  } else {
    className += destructive ? "primary-destructive" : "primary";
  }
  if (disabled) {
    className += " disabled";
  }
  if (small) {
    className += " a-button--small";
  } else if (medium) {
    className += " a-button--medium";
  }
  if (selectedValues && selectedValues.includes(value)) {
    className += " a-button--selected";
  }
  if (selectedValues && !selectedValues.includes(value)) {
    className += " a-button--option";
  }
  if (icon) {
    className += " a-button--icon";
  }
  if (propsClassName) {
    className += " ".concat(propsClassName);
  }
  var TagName = "button";
  var props = _objectSpread(_objectSpread({}, rest), {}, {
    ref: ref,
    className: className,
    onClick: function onClick(e) {
      if (toggleValue) {
        toggleValue(value);
      }
      _onClick && _onClick(e);
    }
  });
  if (href || component) {
    props.tabIndex = 0;
  }
  if (href) {
    TagName = "a";
    if (!disabled) {
      props.href = href;
      props.target = target;
    }
  } else if (component) {
    TagName = component;
    props.disabled = disabled;
    props.value = value;
    props.target = target;
  } else {
    props.disabled = disabled;
    props.type = type;
    props.value = value;
  }
  return /*#__PURE__*/React.createElement(TagName, props, children);
});
AButton.propTypes = {
  /**
   * Sets the base component. Useful for integrating with routers.
   */
  component: PropTypes.elementType,
  /**
   * Toggles the `disabled` state.
   */
  disabled: PropTypes.bool,
  /**
   * If specified, the component will render as an HTML link.
   */
  href: PropTypes.string,
  /**
   * Signifies an icon-only button.
   */
  icon: PropTypes.bool,
  /**
   * Toggles the `primary` style variant. If no style variant is chosen, `primary` is applied.
   */
  primary: PropTypes.bool,
  /**
   * Toggles the `secondary` style variant.
   */
  secondary: PropTypes.bool,
  /**
   * If the `href` or `component` props is set, the target can be set (ex: `_blank`, `_self`, `_parent`, `_top`)
   */
  target: PropTypes.string,
  /**
   * Toggles the `tertiary` style variant.
   */
  tertiary: PropTypes.bool,
  /**
   * Toggles the `tertiaryAlt` style variant.
   */
  tertiaryAlt: PropTypes.bool,
  /**
   * The button type.
   */
  type: PropTypes.oneOf(["button", "submit", "reset"]),
  /**
   * Destructive - button for destructive action, should be used with confirm dialog/modal when clicked
   */
  destructive: PropTypes.bool,
  /**
   * Apply Magnetic small size styles vs only re-skin styles, defaults to false
   */
  small: PropTypes.bool,
  /**
   * Apply Magnetic medium size styles vs only re-skin styles, defaults to false
   */
  medium: PropTypes.bool
};
AButton.displayName = "AButton";
export default AButton;